import { FlatList, Pressable, StyleSheet, View, type ListRenderItemInfo } from 'react-native';
import type { FeatureRouteItem } from '../../constants/expoRoutes';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type FeatureGridProps = {
  features: FeatureRouteItem[];
  onPressFeature: (feature: FeatureRouteItem) => void;
};

export function FeatureGrid({ features, onPressFeature }: FeatureGridProps) {
  const renderFeature = ({ item }: ListRenderItemInfo<FeatureRouteItem>) => (
    <Pressable
      accessibilityRole="button"
      onPress={() => onPressFeature(item)}
      style={({ pressed }) => [styles.featureCell, pressed ? styles.pressed : null]}
    >
      <AppCard style={styles.featureCard}>
        <AppText variant="body" weight="bold">
          {item.title}
        </AppText>
        <AppText variant="caption" tone="muted" numberOfLines={2}>
          {item.description}
        </AppText>
      </AppCard>
    </Pressable>
  );

  return (
    <FlatList
      data={features}
      keyExtractor={(feature) => feature.id}
      renderItem={renderFeature}
      numColumns={2}
      scrollEnabled={false}
      columnWrapperStyle={styles.row}
      ItemSeparatorComponent={Separator}
    />
  );
}

function Separator() {
  return <View style={styles.separator} />;
}

const styles = StyleSheet.create({
  row: {
    gap: tokens.spacing.md,
  },
  featureCell: {
    flex: 1,
  },
  featureCard: {
    minHeight: 112,
    gap: tokens.spacing.sm,
  },
  pressed: {
    opacity: 0.86,
  },
  separator: {
    height: tokens.spacing.md,
  },
});
